module.exports = __webpack_public_path__ + "static/img/no-plan.a60027ba.png";